<template>
  <!-- 新增社保 -->
  <div class="page_addWeb">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>信息维护</el-breadcrumb-item>          <el-breadcrumb-item :to="{ path: '/biddingWebSet' }">招投标网站管理</el-breadcrumb-item>
          <el-breadcrumb-item>合同模板新增/编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-form :model="formData" :rules="rules" :inline="true" ref="webForm" label-width="110px">
          <el-form-item label="平台名称" prop="platformName">
            <el-input v-model="formData.PlatformName"></el-input>
          </el-form-item>
          <el-form-item label="账号管理员" prop="AccountManager">
            <el-select v-model="formData.AccountManager" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'AccountManager','AccountManagerid')}">
              <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册主体" prop="RegisterName">
            <!-- <el-input v-model="formData.RegisterName"></el-input> -->
            <el-select v-model="formData.RegisterName" placeholder="" clearable filterable>
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="投标文件管理员" prop="BiddingManager">
            <el-select v-model="formData.BiddingManager" value-key="Userid" placeholder="" clearable filterable @change="val=>{changePerson(val,'BiddingManager','BiddingManagerid')}">
              <el-option v-for="(item,index) in personnelList" :key="index" :label="item.Username" :value="item"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="网址" prop="WebsiteUrl">
            <el-input v-model="formData.WebsiteUrl"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="formData.Remark" :autosize="{ minRows: 4}" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </div>
          <div class="btnBox">
            <el-button type="success" @click="submitForm" v-preventReClick :disabled="isSuccess">保存</el-button>
            <el-button @click="backHandle">取消</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        formData: {
          Id: '',
          PlatformName: '', //平台名称
          AccountManager: '', //账号管理员
          AccountManagerid: '',
          RegisterName: '', //注册主体
          BiddingManager: '', //投标文件管理员
          BiddingManagerid: '',
          WebsiteUrl: '', //网址
          Remark: '', //备注
        },
        rules: {
          PlatformName: {
            required: true,
            message: "请输入平台名称",
            trigger: "blur",
          }
        },
        personnelList: [], //人员列表
        legList: [], //法务主体列表
        roletype: localStorage.loginRoletype,
        isSuccess:false,
      };
    },
    created() {
      if (this.$route.query.row != undefined && this.$route.query.row) {
        this.formData = JSON.parse(this.$route.query.row);
      }
      this.getauthUserInfoByorgancode();
      this.getlegalsubjectlist();
    },
    methods: {
      // 取消
      backHandle() {
        // window.close()
        this.$router.push({
          path: "/biddingWebSet",
        });
      },
       //获取法务主体列表
       getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      submitForm() {
        this.$refs["webForm"].validate((valid) => {
          if (valid) {
            xz.updateBiddingwebsite(this.formData).then(res => {
              if (res.status == 'ok') {
                this.isSuccess = true;
                this.$message.success('保存成功')
                setTimeout(() => {
                  this.backHandle()
                }, 300);
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })
      },
      //取人员列表
      getauthUserInfoByorgancode() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: ""
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
          if (res.status == "ok") {
            this.personnelList = res.msg;
          } else {
            this.$message.error('获取人员列表失败')
            this.personnelList = [];
          }
        })
      },
      //选择人员
      changePerson(val, name, id) {
        this.formData[id] = val.Userid;
        this.formData[name] = val.Username;
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
    cursor: pointer;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 50px 0;
    width: 98%;
    display: flex;
    justify-content: center;
  }

  .upload_box {
    width: 300px;
  }
</style>
<style>
  .page_addWeb .el-input__inner {
    width: 221px;
  }

  .page_addWeb .el-textarea__inner {
    width: 560px;
  }
</style>